const STORAGE_KEY = "referral_coupon_v1";

// NOTE: the persisted object keeps the legacy `influencerUsername` property name.
// Real users already have this shape stored in their browsers, so the stored
// key is frozen; only the in-memory API uses the new `affiliateUsername` name.

export const getReferralCoupon = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const code = String(parsed?.code || "").trim().toUpperCase();
    const affiliateUsername = String(parsed?.influencerUsername || "").trim();
    if (!code) return null;
    return { code, affiliateUsername: affiliateUsername || null };
  } catch {
    return null;
  }
};

export const setReferralCoupon = ({ code, affiliateUsername } = {}) => {
  const c = String(code || "").trim().toUpperCase();
  const u = String(affiliateUsername || "").trim();
  if (!c) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: c, influencerUsername: u || null }));
  } catch {
    // ignore
  }
};

export const clearReferralCoupon = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};

export const buildReferralSearchParams = ({ code, affiliateUsername } = {}) => {
  const c = String(code || "").trim();
  if (!c) return "";
  const params = new URLSearchParams();
  params.set("ref_coupon", c);
  if (affiliateUsername) params.set("ref_affiliate", String(affiliateUsername));
  const s = params.toString();
  return s ? `?${s}` : "";
};

export const ingestReferralFromSearch = (search) => {
  try {
    const params = new URLSearchParams(search || "");
    const code = params.get("ref_coupon");
    // `ref_influencer` is the legacy param name; accept it so links generated
    // before the affiliate rebrand keep attributing correctly.
    const affiliateUsername = params.get("ref_affiliate") || params.get("ref_influencer");
    if (!code) return null;
    setReferralCoupon({ code, affiliateUsername });
    return { code: String(code).trim().toUpperCase(), affiliateUsername: affiliateUsername || null };
  } catch {
    return null;
  }
};
